/**
 * Whether the campaign is offered in this build.
 *
 * It shipped to dev and local builds first, while it was played and tuned,
 * and stayed out of production until it was ready - the same gate the draft
 * privacy policy uses (`legal/privacy.ts`). It is in production from 0.30.0.
 * Everything that would show a player the campaign still asks this: the
 * home-screen button, both campaign routes, the Progress screen's Campaign
 * panel, and the crest rewards only the campaign can earn.
 *
 * A parameter for the test; the app calls it bare.
 */
const CAMPAIGN_IN_PRODUCTION = true;

export function campaignVisible(appEnv: string | undefined = import.meta.env.VITE_APP_ENV): boolean {
  return CAMPAIGN_IN_PRODUCTION || appEnv !== "prod";
}

/** An achievement only the campaign can unlock. */
export function isCampaignAchievementId(id: string | null | undefined): boolean {
  return !!id && id.startsWith("campaign.");
}
